// src/utils/signalSync.ts

// หลังบ้านแยกสัญญาณแนวรับ-แนวต้านเป็น 2 โหมด: ต้องส่ง assetType ใน body ของ
// POST /signals/updates และ POST /signals/import และเก็บ syncKey แยกกันคนละ key
// (ใช้ syncKey ของหุ้นกับโหมดคริปโต → หลังบ้านตอบ "Invalid sync value.")
import { isCryptoSymbol } from '../composables/fetchCrypto';

export type SignalAssetType = 'STOCK' | 'CRYPTO';
export const SIGNAL_ASSET_TYPES: SignalAssetType[] = ['STOCK', 'CRYPTO'];

// หุ้นใช้ key เดิม เพื่อไม่ให้ผู้ใช้ที่ sync ไว้แล้วถูกรีเซ็ต
export const SIGNAL_SYNC_KEYS: Record<SignalAssetType, string> = {
  STOCK: 'last_signal_sync_time',
  CRYPTO: 'last_signal_sync_time_crypto',
};

export type SignalSyncs = Record<SignalAssetType, string>;
export const EMPTY_SIGNAL_SYNCS: SignalSyncs = { STOCK: '', CRYPTO: '' };

export const signalAssetTypeOf = (ticker: string | null | undefined): SignalAssetType =>
  isCryptoSymbol(ticker) ? 'CRYPTO' : 'STOCK';

export const getSignalSync = (type: SignalAssetType): string => localStorage.getItem(SIGNAL_SYNC_KEYS[type]) || '';

export const setSignalSync = (type: SignalAssetType, value: string) => {
  localStorage.setItem(SIGNAL_SYNC_KEYS[type], value);
};

export const getSignalSyncs = (): SignalSyncs => ({ STOCK: getSignalSync('STOCK'), CRYPTO: getSignalSync('CRYPTO') });

export const clearSignalSyncs = () => {
  SIGNAL_ASSET_TYPES.forEach((type) => localStorage.removeItem(SIGNAL_SYNC_KEYS[type]));
};
